import axios, { AxiosResponse, AxiosError } from 'axios';

// APIレスポンスの型
interface ApiResponse<T = any> {
  success: boolean;
  data: T | null;
  error: any | null;
}

// Axios インスタンスを作成
const axiosService = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    'x-nitti-service': process.env.REACT_APP_SERVICE_CODE
  },
  timeout: 1000 * 120,
  responseType: 'json'
});

// インターセプター: 成功時のレスポンスを変換
axiosService.interceptors.response.use(
  <T>(response: AxiosResponse<T>): AxiosResponse<ApiResponse<T>> => {
    return {
      ...response,
      data: {
        success: true,
        data: response.data,
        error: null
      }
    };
  },
  (error: AxiosError): Promise<AxiosResponse<ApiResponse<null>>> => {
    const errorResponse: ApiResponse<null> = {
      success: false,
      data: null,
      error: error.response?.data ? error.response.data : 'エラーが発生しました'
    };

    return Promise.resolve({
      ...(error.response as AxiosResponse), // 既存のレスポンス情報を維持
      data: errorResponse
    });
  }
);

export default axiosService;
